export default __webpack_public_path__ + "static/media/star.16f9455e.svg";